import { Invitation } from 'src/app/models/invitation';
import * as SystemActions from '../../../store/system/actions/system.actions';
import * as InvitationActions from '../../../store/user/actions/invitations.actions';

export const initialInvitationState = {
    invitations: [],
    loading: false
}

export interface InvitationState {
    invitations: Invitation[],
    loading: boolean
}

export function InvitationsReducer(state = initialInvitationState, action: InvitationActions.InvitationsActions | SystemActions.SystemActions) {
    switch (action.type) {
        case InvitationActions.GET_USER_INVITATIONS:
            return {
                ...state,
                loading : true
            };
        case InvitationActions.GET_USER_INVITATIONS_SUCCESS:
            return {
                ...state,
                invitations : action.payload,
                loading : false
            };
        case InvitationActions.GET_USER_INVITATIONS_FAILURE:
            return {
                ...state,
                loading : false
            };
        case SystemActions.CLEAR_SYSTEM:
            return initialInvitationState;
        default:
            return state;
    }
}